var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillsPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18H28C28.5304 18 29.0391 17.7893 29.4142 17.4142C29.7893 17.0391 30 16.5304 30 16V2C30 1.46957 29.7893 0.960859 29.4142 0.585786C29.0391 0.210714 28.5304 0 28 0ZM8.375 16L2 10.5375V7.4625L8.375 2H21.625L28 7.4625V10.5375L21.625 16H8.375ZM20 9C20 9.98891 19.7068 10.9556 19.1573 11.7779C18.6079 12.6001 17.827 13.241 16.9134 13.6194C15.9998 13.9978 14.9945 14.0969 14.0245 13.9039C13.0546 13.711 12.1637 13.2348 11.4645 12.5355C10.7652 11.8363 10.289 10.9454 10.0961 9.97545C9.90315 9.00555 10.0022 8.00021 10.3806 7.08658C10.759 6.17295 11.3999 5.39206 12.2221 4.84265C13.0444 4.29325 14.0111 4 15 4C16.3261 4 17.5979 4.52678 18.5355 5.46447C19.4732 6.40215 20 7.67392 20 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillsPaymentIcon);
export default __webpack_public_path__ + "static/media/billsPaymentIcon.957b5baf36e9829b8d62f2db0d32f488.svg";
export { ForwardRef as ReactComponent };